import moment from 'moment-timezone'
import { mapState, mapMutations } from 'vuex'
import { OpeningHourCacheMixin } from './OpeningHourCacheMixin'

export const SelectedDateMixin = {
  mixins: [OpeningHourCacheMixin],
  computed: {
    ...mapState('BookingSelectedDate', [
      'selectedDate',
      'localDateString',
      'datePickerInitialStartDate',
      'datePickerStartDate',
      'datePickerEndDate'
    ]),
    ...mapState('TimeZone', [
      'selectedTimeZoneId',
      'loadedTimeZone'
    ]),
    dateString () {
      return moment(this.selectedDate).tz(moment.tz.guess()).format('YYYY-MM-DD')
    },
    startDate () {
      return moment.tz(`${this.dateString}`, this.selectedTimeZoneId)
    },
    endDate () {
      return this.startDate.clone().add(1, 'day')
    },
    selectedDates () {
      if (!this.loadedTimeZone) {
        return {
          start: '',
          end: ''
        }
      } else {
        return {
          start: moment(this.startDate.format()).utc().format(),
          end: moment(this.endDate.format()).utc().format()
        }
      }
    },
    selectedDatesLocal () {
      return {
        fromLocal: this.localDateString ? this.localDateString + 'T00:00:00' : '',
        toLocal: this.localDateString ? this.localDateString + 'T23:59:59' : ''
      }
    }
  },
  watch: {
    closedDays () {
      this.refreshBookingSelectedDate()
    },
    selectedTimeZoneId () {
      this.refreshBookingSelectedDate()
    }
  },
  methods: {
    ...mapMutations('BookingSelectedDate', [
      'setSelectedDate',
      'setDatePickerInitialStartDate',
      'setDatePickerStartDate',
      'setDatePickerEndDate'
    ]),
    findNearestOpenDate (value) {
      let daysChecked = 0
      const maxDays = 366
      while (daysChecked < maxDays) {
        if (!this.closedDays.includes(value.getDay())) {
          return value
        }
        value.setDate(value.getDate() + 1)
        daysChecked++
      }
      return value
    },
    refreshBookingSelectedDate () {
      const initialStartDate = this.findNearestOpenDate(moment().tz(this.selectedTimeZoneId).add(this.siteBookingSettingServiceMinNotice, this.siteBookingSettingServiceMinNoticeUnit)._d)
      this.setSelectedDate(initialStartDate)
      this.setDatePickerInitialStartDate(initialStartDate)
      // Subtract 1 day to ensure the initial date is clickable in the date picker
      const datePickerStartDate = moment(initialStartDate).subtract(1, 'days').toDate()
      this.setDatePickerStartDate(datePickerStartDate)
      this.setDatePickerEndDate(moment(datePickerStartDate).add(this.siteBookingSettingServiceMaxNotice, this.siteBookingSettingServiceMaxNoticeUnit)._d)
    }
  }
}
